// One answer to "is this person a member right now".
//
// This rule was written out by hand in three places - the Users header count,
// the members tab count, and the cash-payment picker - and they did not agree.
// The header counted merged-away accounts, so the club read as having two more
// members than it does: Will Prescott and Chris Shepherd each appeared once as
// themselves and once as the empty shell their duplicate was merged into.
//
// A merged account is not a person. Its payments, subscription and history have
// already moved to the account that survived, so counting it counts somebody
// twice - and because the shell keeps `is_member` from before the merge, it
// counts as a member forever.

// The derived states that mean the club considers somebody a member. AT_RISK is
// deliberately included: an at-risk member has full access, they just have a
// payment question against them. Mirrors MEMBER_STATES on the server.
const MEMBER_STATES = ['ACTIVE', 'AT_RISK'];

/**
 * @param {object} user  a row from /users or /membership/members
 */
export function isCurrentMember(user) {
  if (!user) return false;

  // Whatever else is true of a merged account, it is not a member in its own
  // right. Checked first so it cannot be overridden by a stale flag.
  if (user.merged_into_user_id) return false;

  // The derived state is the answer wherever it has been computed. `is_member`
  // is the fallback for accounts the status engine has not reached yet, and on
  // production before the first reconcile that is all of them.
  if (user.membership_state) return MEMBER_STATES.includes(user.membership_state);
  return Boolean(user.is_member);
}

/**
 * How many of these people are members.
 */
export function countMembers(users) {
  return (users || []).filter(isCurrentMember).length;
}

export { MEMBER_STATES };
